<template>
  <beautiful-chat
    :title="$t('screener.send_notification.title')"
    :participants="participants"
    :onMessageWasSent="onMessageWasSent"
    :messageList="messageList"
    :isOpen="isChatOpen"
    :close="closeChat"
    :open="openChat"
    :showLauncher="true"
    :showCloseButton="true"
    :colors="colors"
    :messageStyling="messageStyling"
  >
    <template v-slot:header>
      <div class="pa-3">
        <div class="title font-weight-regular">{{$t('screener.send_notification.title')}}</div>
        <div class="pt-1">{{$t('screener.send_notification.subtitle')}}</div>
      </div>
    </template>
  </beautiful-chat>
</template>
<script>
export default {
  name: "NotificationsChat",
  props: {
    isChatOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      participants: [],
      messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      //isChatOpen: false, // to determine whether the chat window should be open or closed
      colors: {
        header: {
          bg: "#009688",
          text: "#ffffff"
        },
        launcher: {
          bg: "#009688"
        },
        messageList: {
          bg: "#ffffff"
        },
        sentMessage: {
          bg: "#009688",
          text: "#ffffff"
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222"
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867"
        }
      },
      messageStyling: true
    };
  },
  methods: {
    // Triggered when admin hits Enter/Send button
    async onMessageWasSent(message) {
      try {
        // Sends real time notification to screening page
        let result = await this.$store.dispatch("screener/sendNotification", {
          id: this.$route.params.screener_id,
          message: message.data.text
        });
        this.$store.dispatch("app/showMessage", {
          message: "Message accepted successfully",
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
        });
        this.messageList = [...this.messageList, message];
        if (this.DEFINES.NODE_ENV === "production") {
          this.$ga.event({
            eventCategory: "app.screener.live_notification",
            eventAction:
              "live_notification >> at " +
              new Date().getTime() +
              " >> in >> " +
              this.$route.params.screener_id,
            eventLabel: message.data.text,
            eventValue: 1
          });
        }
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR
        });
      }
    },
    // Triggered on clicking launcher icon
    openChat() {
      // this.isChatOpen = true;
      this.$emit('update:isChatOpen', true)
    },
    // Triggered on clicking close icon
    closeChat() {
      // this.isChatOpen = false;
      this.$emit('update:isChatOpen', false)
    }
  }
};
</script>

<style>
/* Not working with scope */
.sc-launcher,
.sc-open-icon,
.sc-closed-icon {
  margin-bottom: 2% !important;
}
.sc-chat-window {
  bottom: 128px !important;
}
.sc-header--title.enabled {
  pointer-events: none !important;
  cursor: default !important;
}
</style>
